import React, { useEffect, useState } from 'react';
import LogList from '../components/LogList';
import './PilotScreen.css';
import { LogType } from '../interfaces/LogType';
import { SettingsType, UserType } from '../interfaces/SettingsType';
import { getCurrentUserEmail } from '../firebase/auth-helper';
import StatistikWidget from '../components/StatsWidget';
import FilterModal from '../components/FilterModal';
import { FilterType } from '../interfaces/FilterType';

interface PilotScreenProps {
  settings: SettingsType;
  pilots: UserType[];
}

const PilotScreen: React.FC<PilotScreenProps> = ({ settings, pilots }) => {
  const [pilotId, setPilotId] = useState<string>();
  const [isFilterModalOpen, setIsFilterModalOpen] = useState<boolean>(false);
  const [activeFilters, setActiveFilters] = useState<FilterType[]>([]);

  useEffect(() => {
    const email = getCurrentUserEmail();

    setPilotId(email);
  }, []);

  useEffect(() => {
    setActiveFilters([{ field: 'pilotId', operator: '==', value: pilotId }]);
  }, [pilotId]);

  return (
    <div className="pilot-container">
      <div className="pilot-welcome-widget">
        <div className="pilot-greeting-container">
          <h2 className="pilot-greeting">Hallo, {settings?.prename}!</h2>
        </div>

        <div className="pilot-dashboard">
          {settings.isAdmin && (
            <div className="dashboard-item-pilotchoice">
              <strong>Pilotauswahl:</strong>
              <select
                value={pilotId}
                onChange={(e) => setPilotId(e.currentTarget.value)}
              >
                <option
                  key={getCurrentUserEmail()}
                  value={getCurrentUserEmail()}
                >
                  {settings.prename + ' ' + settings.lastname}
                </option>
                {settings.userList.map((pilot) => (
                  <option key={pilot.email} value={pilot.email}>
                    {pilot.prename + ' ' + pilot.lastname}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
        <StatistikWidget pilotId={pilotId} />
      </div>
      <div className="pilot-loglist">
        <div className="drone-header">
          <h2>Dein Flugbuch</h2>
          <div className="button-group">
            {/** <button className="add-button">+ Neuer Flug</button> */}
            <button
              className="filter-button"
              onClick={() => setIsFilterModalOpen(true)}
            >
              Filter
            </button>
          </div>
        </div>
        {pilotId && (
          <LogList
            settings={settings}
            pilots={pilots}
            isAdmin={settings.isAdmin}
            pilotId={pilotId}
            showDroneId={true}
            filters={activeFilters}
          />
        )}
        {isFilterModalOpen && (
          <FilterModal
            onClose={() => setIsFilterModalOpen(false)}
            onApply={(filters: FilterType[]) => {
              setActiveFilters([
                ...filters,
                { field: 'pilotId', operator: '==', value: pilotId },
              ]);
            }}
            settings={settings}
          />
        )}
      </div>
    </div>
  );
};

export default PilotScreen;
